import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

const HeaderContainer = styled.header`
    background-color: #fff;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.5rem;
    font-weight: bold;

    img {
        height: 40px;
        width: auto;
    }
`;

const LogoutButton = styled.button`
    background-color: #f44336;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
        background-color: #d32f2f;
    }
`;

const Header = () => {
    const { logout, isAuthenticated } = useAuth();
    const location = useLocation();
    const isLoginPage = location.pathname === '/' || location.pathname === '/login';

    return (
        <HeaderContainer>
            <LogoContainer>
                {isAuthenticated && (
                    <>
                        <img src="/header-logo.png" alt="Adventour Paris" />
                        <img src="/guideworks-logo.png" alt="Guide Works" />
                    </>
                )}
                <div>Guide dashboard</div>
            </LogoContainer>
            {!isLoginPage && (
                <LogoutButton onClick={logout}>Logout</LogoutButton>
            )}
        </HeaderContainer>
    );
};

export default Header;
